import { useMemo } from 'react';

import { useGetFileSummaryNewUi } from '../DossierFileSummary/FileSummaryNewUi.hooks';

export interface DisplayActorNameProps {
  actorId: string;
  actorType?: string;
  sellerId?: string;
  ownerId?: string;
}

const DisplayActorName = ({ actorId }: DisplayActorNameProps) => {
  const { data } = useGetFileSummaryNewUi();

  const label = useMemo(() => {
    if (!data) {
      return actorId;
    }

    if (data.fullSummary.actorId === actorId) {
      return data.context.assignedUserName || actorId;
    }

    if (data.fullSummary.siteActorId === actorId) {
      return data.context.siteActorName || actorId;
    }

    if (data.fullSummary.storeActorId === actorId) {
      return data.context.storeActorName || actorId;
    }

    return actorId;
  }, [actorId, data]);

  return <>{label}</>;
};

export default DisplayActorName;
